import { TweenLite, TweenMax, TimelineLite } from 'gsap';
import ScrollMagic from 'scrollmagic';
import ScrollMagicController from '../class/ScrollMagicController';
import { Expo } from 'gsap/gsap-core';

class Presentation {
	constructor() {
		this.sections = document.querySelectorAll('.presentation');
		this.animate();
	}

	animate() {
		this.sections.forEach((section) => {
			const timeline = new TimelineLite();

			const title = section.querySelectorAll('.title, .surtitle');
			if (title.length) {
				const titleAnimation = TweenMax.staggerFromTo(
					title,
					0.3,
					{ y: 150, autoAlpha: 0 },
					{ y: 0, autoAlpha: 1 },
					0.1
				);
				timeline.add(titleAnimation);
			}

			const blocks = section.querySelector('.presentation-content');
			if (blocks) {
				const blocksAnimation = TweenMax.fromTo(blocks, 0.3, { y: 150, autoAlpha: 0 }, { y: 0, autoAlpha: 1 });
				timeline.add(blocksAnimation);
			}

			const button = section.querySelector('.presentation__cta-wrapper--cta-right .cta');
			if (button) {
				const buttonAnimation = TweenMax.fromTo(button, 0.3, { x: 300, autoAlpha: 0 }, { x: 0, autoAlpha: 1 });
				timeline.add(buttonAnimation);
			}

			new ScrollMagic.Scene({
				triggerElement: section,
				triggerHook: 0.85,
				offset: 0,
				reverse: false,
			})
				.setTween(timeline)
				.addTo(ScrollMagicController.controller);
		});
	}
}

export default Presentation;
